import React from 'react';

const Card = ({ children }) => {
  return (
    <>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        {`
          .gradient-border {
            --algo-olio-gradient-dark: linear-gradient(317deg, 
              #A29EDA -26.21%, 
              #B292D1 -10.9%, 
              #B557AF 38.67%, 
              #6B3A8F 78.77%, 
              #5D2A79 115.46%
            );
            border: 2px solid transparent;
            border-radius: 24px;
            background-image: 
              linear-gradient(144deg, #1D151D 42.84%, #4E2D33 179.39%),
              var(--algo-olio-gradient-dark);
            background-origin: border-box;
            background-clip: padding-box, border-box;
            boxShadow: 10px 10px 80px 0px rgba(63, 39, 102, 0.25);
            backdropFilter: blur(10px);
            padding: 2rem;
            color: #e1e1e6;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
        }
        `}
      </style>
      
      <div className="gradient-border">
        {children}
      </div>
    </>
  );
};

export default Card;